import scrollLock from 'scroll-lock';

export default class Intro {
	constructor() {
		this.intro = document.querySelector('.intro');

		if (!this.intro) {
			return;
		}

		this.logo = document.querySelector('.intro__text--wrapper');
		this.logoSpan = document.querySelectorAll('.intro__text');
		this.backgroundImage = document.querySelector('.intro__image');

		window.addEventListener('DOMContentLoaded', () => {
			const hasRunBefore = sessionStorage.getItem('hasRunBefore');
			if (!hasRunBefore && this.intro) {
				setTimeout(() => {
					scrollLock.disablePageScroll();
					this.logoSpan.forEach((span, index) => {
						setTimeout(() => {
							span.classList.add('active');
						}, 400);
					});

					setTimeout(() => {
						this.logoSpan.forEach((span, index) => {
							setTimeout(() => {
								span.classList.remove('active');
								span.classList.add('fade');
							});
						});
					}, 3000);

					setTimeout(() => {
						this.intro.style.transform = 'scale(100%)';
						this.intro.classList.add('fade');
						this.backgroundImage.classList.add('fade');
						this.logo.classList.add('active');
					}, 3000);

					setTimeout(() => {
						scrollLock.enablePageScroll();
						sessionStorage.setItem('hasRunBefore', true);
					}, 3000);
				});
			} else {
				this.intro.remove();
			}
		});
	}
}
